import {FC} from 'react';
import {ShowMore as ReactTruncate} from '@re-dev/react-truncate';
import {Box} from '@chakra-ui/react';

import './ShowMore.css';

interface IProps {
  text: string;
  lines?: number;
}

export const ShowMore: FC<IProps> = ({text, lines = 3}) => {
  return (
    <Box w={'100%'}>
      <ReactTruncate
        lines={lines}
        anchorClass={'show-more-link'}
        more={'Show more'}
        less={'Show less'}
      >
        {text}
      </ReactTruncate>
    </Box>
  );
};
